import { io, type Socket } from "socket.io-client";
import type { ClientToServerEvents, ServerToClientEvents } from "@shared/types";

export type LfrSocket = Socket<ServerToClientEvents, ClientToServerEvents>;

/** Abre a conexao autenticada com o servidor do LFRCORD. */
export function connectSocket(sessionToken: string): LfrSocket {
  return io({
    auth: { token: sessionToken },
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionDelay: 600,
    reconnectionDelayMax: 4_000,
  });
}
